// extracted by mini-css-extract-plugin
export default {"selectAddress":"styles_selectAddress__iKf5l"};